import {Grid, makeStyles} from "@material-ui/core";
import React, {FC} from "react";
import {useParams} from "react-router-dom";
import {PersonHeadline} from "../../../sharedComponents/PersonHeadline";
import {useClient} from "../redux/clients.hook";
import {ClientProfileCard} from "./ClientProfileCard";
import {ClientOrdersTable} from "../table/ClientOrdersTable";
import {CreateOrderDialogForm} from "../../orders/form/CreateOrderDialogForm";

const useStyles = makeStyles(() => ({
    card: {
        height: "100%"
    }
}))

export const ClientScreen: FC = () => {
    const classes = useStyles();
    const {id} = useParams<{ id: string }>();
    const {client} = useClient(id);

    return (
        <React.Fragment>
            <PersonHeadline person={client}/>
            <div style={{paddingBottom: 24}}>
                <CreateOrderDialogForm initialClientId={id}/>
            </div>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <ClientProfileCard
                        client={client}
                        cardProps={{className: classes.card}}
                    />
                </Grid>
                <Grid item xs={8}>
                    <ClientOrdersTable clientId={id}/>
                </Grid>
            </Grid>
        </React.Fragment>
    )
}
